import { render, staticRenderFns } from "./AlertContent.vue?vue&type=template&id=cfa11dee"
import script from "./AlertContent.vue?vue&type=script&lang=js"
export * from "./AlertContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports